export default {
  sections: [
    {
      name: 'Introduction',
      path: '/'
    },
    {
      name: 'Design Tokens'
    },
    {
      name: 'Layout'
    },
    {
      name: 'Typography'
    },
    {
      name: 'Data Input'
    },
    {
      name: 'Data Display'
    },
    {
      name: 'Navigation'
    }
  ]
}
